import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import Requests from "../../pages/services/Requests";

const MonthlyStats = () => {
  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: "line",
      stacked: false,
      height: "100%",
      width: "100%",
    },
    dataLabels: {
      enabled: false,
    },
    series: [
      {
        name: "clients",
        data: [],
      },
      {
        name: "appointments",
        data: [],
      },
    ],
    xaxis: {
      categories: [],
    },
    colors: ["#2a9d36", "#c70e2a"],
    stroke: {
      width: 1,
      curve: "smooth",
    },
    markers: {
      size: 3,
    },
    grid: {
      show: true,
      borderColor: "#ebebeb",
      strokeDashArray: 2,
    },
    tooltip: {
      theme: "dark",
    },
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await Requests.getDashboardStats();

        if (response.data.success && response.data.data.monthly_stats) {
          const monthlyData = response.data.data.monthly_stats;

          // Extract data for chart
          const months = monthlyData.map(item => item.month);
          const clientsData = monthlyData.map(item => item.clients);
          const appointmentsData = monthlyData.map(item => item.appointments);

          setChartOptions(prev => ({
            ...prev,
            series: [
              {
                name: "clients",
                data: clientsData,
              },
              {
                name: "appointments",
                data: appointmentsData,
              },
            ],
            xaxis: {
              categories: months,
            },
          }));
        }
      } catch (err) {
        console.error("Error fetching dashboard stats:", err);
        setError("Failed to load monthly statistics");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.ApexCharts && window.ApexCharts.mL) {
        window.ApexCharts.mL.updateOptions({
          chart: {
            width: "100%",
          },
        });
        window.ApexCharts.mL.updateSeries(chartOptions.series);
        window.ApexCharts.mL.render();
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [chartOptions]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-5 text-danger">
        {error}
      </div>
    );
  }

  return (
    <div>
      <ReactApexChart
        options={chartOptions}
        series={chartOptions.series}
        type="line"
        height="300"
      />
    </div>
  );
};

export default MonthlyStats;